module.exports = __webpack_public_path__ + "img/23.f7b9a1af.png";